<!--
 * @Author: ker
 * @Date: 2020-10-26
 * @LastEditors: ker
 * @LastEditTime: 2020-10-26
 * @Description: 员工邀请加入
 -->
<template>
  <w-dialog :show="isShow"
            confirm
            class="invite"
            show-close
            :appendToBody="false"
            title="邀请人员加入企业"
            :box-style="{width: '860px'}"
            :bodyStyle="{padding: 0}"
            @close="close">
    <div class="invite-wrapper" style="padding: 16px 24px 35px 24px;">
      <div class="invite-mode" v-if="isAdmin">
        <w-radio-group size="mini" v-model="auditState" style="margin-bottom: 24px;" @change="getInvitationInfo">
          <w-radio :label="0">
              <span class="invite-mode-text">
                无需审核模式 <span class="mode-desc">员工填写信息后直接加入企业</span>
              </span>
          </w-radio>
          <!--<w-radio :label="1" style="margin-top: 6px;">-->
              <!--<span class="invite-mode-text">-->
                <!--审核模式 <span class="mode-desc">员工填写信息后需要您审核同意后加入企业</span>-->
              <!--</span>-->
          <!--</w-radio>-->
        </w-radio-group>
      </div>
      <div class="invite-body" v-loading="loading">
        <div class="invite-item invite-code">
          <div class="invite-title">二维码邀请</div>
          <div class="invite-container">
            <img :src="qrUrl">
            <!--<img src="/img/r2-qr-code.4b3606b2.png">-->
          </div>
          <div class="invite-operate">
            扫描二维码加入<template v-if="companyName">「{{companyName}}」</template>企业
          </div>
        </div>
        <div class="invite-item invite-link">
          <div class="invite-title">链接邀请</div>
          <div class="invite-container">
            <div class="invite-link-text">
              邀你加入<template v-if="companyName">「{{companyName}}」</template>企业：{{shortLink}}
            </div>
          </div>
          <div class="invite-operate">
            <w-button v-clipboard="{value: companyName + '邀请你加入企业，一起使用广联达企业账号特权功能。点击链接：' + shortLink + '，填写信息即可加入。', success: clipboardSuccess}">复制链接</w-button>
            <!--copyLink()-->
          </div>
        </div>
        <div class="invite-item invite-link">
          <div class="invite-title">企业邀请码</div>
          <div class="invite-container">
            <div class="invite-link-text" style="text-align: center; padding: 0; line-height: 138px; font-size: 20px;">
              {{shareKey}}
            </div>
          </div>
          <div class="invite-operate">
            <w-button v-clipboard="{value: shareKey, success: copyShareKeySuccess}">复制邀请码</w-button>
          </div>
        </div>
      </div>
      <div class="invite-footer">
        <template v-if="isAdmin">
          <template v-if="!auditState">
            二维码或分享链接3天后失效
          </template>
        </template>
        <template v-else>
          扫码或点击链接填写信息后，需要您企业的管理员（联系方式：{{adminMobile}}）审核同意后方可加入企业
        </template>
      </div>
    </div>
  </w-dialog>
</template>

<script>
import QRCode from 'qrcode'
// import {getCookie} from '@/assets/utils/CommonUtil'
import messageService from '@/assets/service/message'

export default {
  name: 'invite',
  data () {
    return {
      isShow: false,
      auditState: 0,
      // companyName: '中建一局',
      adminMobile: '',
      qrUrl: '',
      shortLink: '',
      shareKey: '',
      loading: false
    }
  },
  computed: {
    companyName () {
      return (this.user.companyName || '')
    },
    isAdmin () {
      // 是否是管理员或者总负责人
      return [1, 2].includes(this.user.role)
    }
  },
  mounted () {
    if ([1, 2].includes(this.user.role)) {
      this.auditState = 0
    } else {
      this.auditState = 1
    }
    this.getInvitationInfo(this.auditState)
  },
  methods: {
    // 获取邀请信息
    getInvitationInfo (auditState) {
      this.sentLog(100117043, {auditState})
      this.loading = true
      messageService.getInvitationInfo({auditState, clientType: 'WEB'}).then(res => {
        this.loading = false
        if (res.code === 200) {
          const {shortLink, adminMobile, shareKey} = res.data || {}
          this.generateCode(shortLink)
          this.adminMobile = adminMobile
          this.shortLink = shortLink
          this.shareKey = shareKey
          this.isShow = true
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {
        this.loading = false
        this.$message.error(error.message)
      })
    },
    // 生成二维码
    generateCode (url = '') {
      QRCode.toDataURL(url, {
        width: 128,
        height: 128,
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 3,
        color: {
          // dark:"#010599FF",
          // light:"#FFBF60FF"
        }
      }).then(url => {
        this.qrUrl = url
      }).catch(err => {
        this.$message.error(err.method())
      })
    },
    close () {
      // // 设置埋点userId为gldID
      // const zjyUserInfo = JSON.parse(getCookie('ZJYUSERINFO'))
      // if (zjyUserInfo && zjyUserInfo.gldUserId) {
      //   ga('set', 'userId', zjyUserInfo.gldUserId)
      // }
      this.onInstanceClose(this.boxId)
      this.isShow = false
      // const type = agree ? 1 : 0
      // if (type) {
      //   // 设置 隐私协议 已阅读并同意
      //   service.user.setPrivacy({type}).then((data) => {
      //     // if (!agree){
      //     //   // 没同意隐私协议
      //     //   this.isAgree = false
      //     // }
      //   })
      // }
    },
    // 复制邀请链接成功
    clipboardSuccess () {
      this.sentLog(100117100)
      this.$message.success('链接复制成功')
    },
    // 复制邀请码成功
    copyShareKeySuccess () {
      this.sentLog(100117101)
      this.$message.success('企业邀请码复制成功')
    }
  }
}
</script>

<style lang="less" type="text/less">
  @import "Index";
</style>
